"use strict";
/*
 * Created on 29. 11. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fs = require("fs");

var moment = require("moment");
/**
 * Utility methods for filesystem.
 *
 * @author Radek Beran
 */


var Files =
/*#__PURE__*/
function () {
  function Files() {
    _classCallCheck(this, Files);
  }

  _createClass(Files, null, [{
    key: "exists",
    value: function exists(filePath) {
      var fileExistsPromise = function fileExistsPromise(path, mode) {
        return new Promise(function (resolve, reject) {
          fs.access(path, mode, function (error) {
            if (error) {
              resolve(false);
            }

            resolve(true);
          });
        });
      };

      return fileExistsPromise(filePath, fs.constants.F_OK);
    }
  }, {
    key: "rename",
    value: function rename(oldPath, newPath) {
      var fileRenamePromise = function fileRenamePromise(_oldPath, _newPath) {
        return new Promise(function (resolve, reject) {
          fs.rename(_oldPath, _newPath, function (error) {
            if (error) {
              resolve(false);
            }

            resolve(true);
          });
        });
      };

      return fileRenamePromise(oldPath, newPath);
    }
  }, {
    key: "getModifyTime",
    value: function getModifyTime(filePath) {
      var modifyTimePromise = function modifyTimePromise(path) {
        return new Promise(function (resolve, reject) {
          fs.stat(path, function (error, stats) {
            if (error) {
              reject(new Error("Cannot load modify time of ".concat(path, ". Error: ").concat(error.code, "\n").concat(error.stack)));
            }

            resolve(moment(stats.mtime));
          });
        });
      };

      return modifyTimePromise(filePath);
    }
  }]);

  return Files;
}();

exports.Files = Files;